import React, { useEffect, useMemo, useRef } from 'react';

import ArrowRightShort from 'assets/icons/arrowRightShort.svg';
import cn from 'classnames/bind';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Slider from 'ui/components/Slider';
import { getCategoryHref } from 'utils/links';
import twMerge from 'utils/twMerge';

const CategoryLink = ({ url, title, isActive }) => (
  <div
    className={twMerge(
      cn('px-3 mr-2 py-[6px] bg-white rounded-full', {
        'bg-orange text-white': isActive,
      })
    )}
  >
    <Link href={url} className="text-[16px] leading-[20px] font-semibold">
      {title}
    </Link>
  </div>
);

const NavigationButton = ({ className }) => (
  <button
    className={twMerge(
      'absolute top-0 flex items-center justify-center w-8 h-8 bg-white rounded-full',
      className
    )}
  >
    <ArrowRightShort />
  </button>
);

const BlogCategorySlider = ({ categories }) => {
  const slider = useRef(null);
  const router = useRouter();

  const listItems = useMemo(() => {
    const items = categories.map((category) => ({
      ...category,
      url: getCategoryHref(category.slug),
    }));
    items.unshift({
      title: 'All',
      slug: 'all',
      url: '/blog',
    });
    return items;
  }, [categories]);

  useEffect(() => {
    slider.current?.setSlide(
      listItems.findIndex((listItem) => listItem.url === router.asPath)
    );
  }, [router.asPath, listItems]);

  return (
    <div className="relative mb-[30px] swiper-auto-width px-10">
      <Slider
        slidesPerView="auto"
        freeMode={true}
        pagination={false}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'opacity-50 cursor-default',
        }}
        ref={slider}
      >
        {listItems.map((listItem) => (
          <CategoryLink
            key={listItem.slug}
            url={listItem.url}
            title={listItem.title}
            isActive={router.asPath === listItem.url}
          />
        ))}
      </Slider>
      <NavigationButton className="swiper-button-prev left-0 rotate-180" />
      <NavigationButton className="swiper-button-next right-0 " />
    </div>
  );
};

export default BlogCategorySlider;
